import { takeLatest } from 'redux-saga/effects';
import { signUpSaga } from './saga';
import * as actionTypes from './actionTypes';

export default function* watchSignUp() {
    yield takeLatest(actionTypes.SIGN_UP_USER, signUpSaga);
}